module.exports = __webpack_public_path__ + "static/media/network.0ac185e3.png";